import { fetcher } from '@commenda/utils';

export async function deleteSecureInformationRequest(
  secureInformationRequestId: string,
  token?: string
) {
  const response = await fetcher(
    `secureInformationRequest/${secureInformationRequestId}`,
    {
      method: 'DELETE',
    },
    token
  );

  return response;
}
